export default "__VITE_ASSET__BHUYXNDT__"